import { render, staticRenderFns } from "./upload-face.vue?vue&type=template&id=2985e398&scoped=true"
import script from "./upload-face.vue?vue&type=script&lang=js"
export * from "./upload-face.vue?vue&type=script&lang=js"
import style0 from "./upload-face.vue?vue&type=style&index=0&id=2985e398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985e398",
  null
  
)

export default component.exports